import { format, isValid } from 'date-fns'

const DATE_FORMATS: Record<string, string> = {
  en: 'MMM d, yyyy',
  ro: 'd MMM yyyy',
}

const DATETIME_FORMATS: Record<string, string> = {
  en: 'MMM d, yyyy HH:mm',
  ro: 'd MMM yyyy HH:mm',
}

export function getDateFormat(locale: string): string {
  return DATE_FORMATS[locale] ?? DATE_FORMATS.en
}

export function formatAppDate(value: string | Date | null | undefined, locale: string): string {
  if (!value) return '—'
  const d = value instanceof Date ? value : new Date(value)
  if (!isValid(d)) return '—'
  return format(d, getDateFormat(locale))
}

export function formatAppDateTime(value: string | Date | null | undefined, locale: string): string {
  if (!value) return '—'
  const d = value instanceof Date ? value : new Date(value)
  if (!isValid(d)) return '—'
  const fmt = DATETIME_FORMATS[locale] ?? DATETIME_FORMATS.en
  return format(d, fmt)
}

export function formatTimeAgo(date: string | Date): string {
  const now = new Date()
  const diffMs = now.getTime() - new Date(date).getTime()
  const diffMins = Math.floor(diffMs / 60000)
  if (diffMins < 1) return 'just now'
  if (diffMins < 60) return `${diffMins}m ago`
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h ago`
  const diffDays = Math.floor(diffHours / 24)
  return `${diffDays}d ago`
}
